export default __webpack_public_path__ + "9cc27396bb81d7c296abeffd7d5146dd.jpg";